const settings = {
    ISPROD : true    
}

export const apiConstants = {
    ISPROD : settings.ISPROD , 
    
    ENDPOINT : (settings.ISPROD) ? ( 'https://appstream.dyndns-wiki.com/hwggexcore/api/' ) : ( 'https://localhost:44323/api/' ) ,
    DOMAIN :  (settings.ISPROD) ? ( 'https://appstream.dyndns-wiki.com/hwggexcore/' ) : ('https://localhost:44323/') , 
    WEBDOMAIN : (settings.ISPROD) ? ( 'http://hwgb.appstream.com.my/' ) : ('https://localhost:3000/')
    /*
    ENDPOINT : (settings.ISPROD) ? ( 'https://admin.hwgexchange.com/api/' ) : ( 'https://localhost:44323/api/' ) ,
    DOMAIN :  (settings.ISPROD) ? ( 'https://admin.hwgexchange.com/' ) : ('https://localhost:44323/') , 
    WEBDOMAIN : (settings.ISPROD) ? ( 'https://www.hwgexchange.com/' ) : ('https://localhost:3000/')*/
}   


// WEBPACK FOOTER //
// ./src/_constants/api.constants.js